export const interventiInitFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? '-data_intervento',
  tipo_intervento: params.get('tipo_intervento') ?? '',
  stato: params.get('stato') ?? '',
  esito: params.get('esito') ?? '',
  cliente: params.get('cliente') ?? '',
  data_intervento__gte: params.get('data_intervento__gte') ?? '',
  data_intervento__lte: params.get('data_intervento__lte') ?? '',
  bilancia: params.get('bilancia') ?? '',
})

export const areFiltersActive = (filters: any) => {
  return Object.keys(filters).some((key) => {
    if (key === 'page') {
      return false
    }
    if (key === 'search') {
      return filters[key] !== ''
    }
    if (key === 'ordering') {
      return filters[key] !== '-data_intervento'
    }
    if (key === 'tipo_intervento') {
      return filters[key] !== ''
    }
    if (key === 'stato') {
      return filters[key] !== ''
    }
    if (key === 'esito') {
      return filters[key] !== ''
    }
    if (key === 'cliente') {
      return filters[key] !== ''
    }
    if (key === 'data_intervento__gte') {
      return filters[key] !== ''
    }
    if (key === 'data_intervento__lte') {
      return filters[key] !== ''
    }
    if (key === 'bilancia') {
      return filters[key] !== ''
    }
    return false
  })
}